import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedTrace {
  wagonId: string;
  wheelId: number;
  wagonName: string;
}

interface GraphTracesState {
  selectedTraces: SelectedTrace[];
  traceCount: number;
}

const initialState: GraphTracesState = {
  selectedTraces: [],
  traceCount: 0,
};

const graphTracesSlice = createSlice({
  name: 'graphTraces',
  initialState,
  reducers: {
    setGraphTraces: (state, action: PayloadAction<SelectedTrace[]>) => {
      state.selectedTraces = action.payload;
      state.traceCount = action.payload.length;
    },
    clearGraphTraces: (state) => {
      state.selectedTraces = [];
      state.traceCount = 0;
    },
  },
});

export const { setGraphTraces, clearGraphTraces } = graphTracesSlice.actions;
export default graphTracesSlice.reducer;

